import React, { useCallback, useState, useEffect } from 'react';
import IssuerInstallmentSelect from 'components/pages/checkout/payment/issuer_installment_select';
import SavedCardsContainer from 'components/pages/checkout/payment/saved_cards/saved_cards_container';

const Card = (props) => {
  const {
    sqCard,
    issuerInstallmentsEnabled,
    issuerInstallmentsCardBrands,
    issuerInstallmentsTerm,
    setIssuerInstallmentsTerm,
    showIssuerInstallmentsSelect,
    setShowIssuerInstallmentsSelect,
    canUseSavedCard,
    selectedCard,
    setSelectedCard,
  } = props;
  const [showCardForm, setShowCardForm] = useState(true);

  const hideIssuerInstallmentSelect = () => {
    setShowIssuerInstallmentsSelect(false);
    setIssuerInstallmentsTerm(null);
  };

  // hide the installment term selection on card brand change if ineligible
  const onCardBrandChanged = useCallback(
    (event) => {
      const brandEligible = issuerInstallmentsCardBrands.includes(
        event.detail.cardBrand.toLowerCase(), // sets to 'unknown' when form cleared
      );

      // if brand is not eligible, reset the term selection
      if (!brandEligible) {
        hideIssuerInstallmentSelect();
      }
    },
    [
      issuerInstallmentsCardBrands,
      setIssuerInstallmentsTerm,
      setShowIssuerInstallmentsSelect,
    ],
  );

  // hide the installment term selection on card number errors
  const onErrorClassAdded = useCallback(
    (event) => {
      if (event.detail.field === 'cardNumber') {
        hideIssuerInstallmentSelect();
      }
    },
    [setShowIssuerInstallmentsSelect, setIssuerInstallmentsTerm],
  );

  useEffect(() => {
    if (sqCard && issuerInstallmentsEnabled) {
      sqCard.addEventListener('cardBrandChanged', onCardBrandChanged);
      sqCard.addEventListener('errorClassAdded', onErrorClassAdded);
    }

    return () => {
      if (sqCard && issuerInstallmentsEnabled) {
        sqCard.removeEventListener('cardBrandChanged');
        sqCard.removeEventListener('errorClassAdded');
      }
    };
  }, [
    sqCard,
    issuerInstallmentsEnabled,
    canUseSavedCard,
    onCardBrandChanged,
    onErrorClassAdded,
  ]);

  return (
    <div data-testid="card-component" style={{ position: 'relative' }}>
      <div
        id="empty-div-for-payment-form"
        style={{ display: showCardForm ? 'block' : 'none' }}
      />
      <SavedCardsContainer
        dropdownTopPosition={50}
        dropdownLeftPosition={0}
        setShowCardForm={setShowCardForm}
        sqCard={sqCard}
        canUseSavedCard={canUseSavedCard}
        selectedCard={selectedCard}
        setSelectedCard={setSelectedCard}
      />

      {showIssuerInstallmentsSelect && (
        <IssuerInstallmentSelect
          issuerInstallmentsTerm={issuerInstallmentsTerm}
          setIssuerInstallmentsTerm={setIssuerInstallmentsTerm}
        />
      )}
    </div>
  );
};

export default Card;
